<template>
  <div></div>
</template>
<script>
import { LOGIN_ONLY_WITH_QQ, LOGIN_ONLY_WITH_WX } from './constant';
import Vue from 'vue';

export default {
  name: 'check-on-login',
  props: {
    option: {
      type: Object,
      default: () => ({}),
    },
    imposeLoginType: {
      type: Number,
    },
  },
  data() {
    return { };
  },
  computed: {
    options() {
      return Object.assign({
        // cid: '', // 当前组件cid
        // uid: '', // 当前组件uid
        // uname: '', // 当前组件uname
      }, this.option);
    },
    currentAccType() {
      if (!Vue.prototype?.$storeInstance?.state?.isLogin) {
        return '';
      }
      return Vue.prototype?.$storeInstance?.state?.userInfo?.acctype;
    },
    currentAccTypeIsWX() {
      return this.currentAccType === 'wx';
    },
    currentAccTypeIsQQ() {
      return this.currentAccType === 'qc';
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.currentAccTypeIsWX && this.imposeLoginType === LOGIN_ONLY_WITH_QQ) {
        this.confirmMsg('当前活动仅限QQ用户参与', '切换为QQ登录');
        this.reportExposeFunc('show_pop', { pop_name: 'login_impose' });
        return;
      }
      if (this.currentAccTypeIsQQ && this.imposeLoginType === LOGIN_ONLY_WITH_WX) {
        this.confirmMsg('当前活动仅限微信用户参与', '切换为微信登录');
        this.reportExposeFunc('show_pop', { pop_name: 'login_impose' });
        return;
      }
      this.$emit('check-result', 0);
    },
    confirmMsg(tipMsg, confirmMsg) {
      const that = this;
      Vue.prototype?.$confirm({
        msg: tipMsg,
        confirmText: confirmMsg,
        cancel() {
          that.$emit('check-result', 2);
          that.reportFunc('click_pop', { pop_name: 'login_impose', type: 'cancel' });
        },
        confirm() {
          that.$emit('check-result', 1);
          that.reportFunc('click_pop', { pop_name: 'login_impose', type: 'switch' });
        },
      });
    },
    reportFunc(eventKey, eventData) {
      if (
        typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0]
          === 'function'
      ) {
        const params = {
          ceibaComponentId: `${this.options.cid || ''}`,
          ceibaComponentUid: this.options.uid || '',
          ceibaComponentUname: this.options.uname || 'base_login_pop',
          eventKey,
          eventData,
        };
        console.log('reportFunc reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      }
    },
    reportExposeFunc(eventKey, eventData) {
      if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          ceibaComponentId: `${this.options.cid || ''}`,
          ceibaComponentUid: this.options.uid || '',
          ceibaComponentUname: this.options.uname || 'base_login_pop',
          eventType: 1001,
          eventKey,
          eventData,
        };
        console.log('reportExposeFunc reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      }
    },
  },
};
</script>

<style scoped>

</style>

